import VueEvents from '@cm-frontend/commons/src/maker/vue-files/events.js';

export default function ($root) {
  VueEvents($root);
  // Extends
}
